const {getCheckedItems} = require("./helper/labour");

class SimulationEvent {
  constructor() {
  }

  watch(target, cb) {
    target.addEventListener('change', (e) => {
      cb(e);
    });
  }

  trigger(target) {
    target.dispatchEvent(new Event("change", {
      bubbles: true,
      target: target
    }));
  }

  triggerAll(targets) {
    for (let i = 0; i < targets.length; i++) {
      this.trigger(targets[i]);
    }
  }

  fetchInputs(targets) {
    let inputValues = {};
    for (const ele in targets) {

      if (ele === "optionsEle") {

        const checkboxes = targets[ele].querySelectorAll(".checkbox");
        const items = getCheckedItems(checkboxes);

        inputValues = {
          ...inputValues,
          [ele]: items
        }


      } else {
        const value = targets[ele].value;
        inputValues = {
          ...inputValues,
          [ele]: value
        }
      }
    }

    for (const ele in inputValues) {
      if (!inputValues[ele]) {
        return false;
      }
    }

    return inputValues;
  }
}

module.exports = SimulationEvent;
